import Blockly from 'blockly'
import 'blockly/python'

let blockJson = {
  type: 'machine_ifline_mortor_ir_get',
  message0: '%{BKY_CUSTOM_MACHINE_IFLINE_MORTOR_IR_GET}',
  args0: [
    {
      type: 'field_image',
      src: 'https://i.ibb.co/SwWXQ3k/ifline.jpg',
      width: 30,
      height: 30,
      alt: '*'
    },
    {
      type: 'field_dropdown',
      name: 'IR',
      options: [
        ['%{BKY_CUSTOM_MACHINE_IFLINE_MORTOR_IR_GET_V_LEFT}', 'mortorIrLeft'],
        ['%{BKY_CUSTOM_MACHINE_IFLINE_MORTOR_IR_GET_V_RIGHT}', 'mortorIrRight']
      ]
    }
  ],
  output: 'Number',
  style: 'sensor_blocks',
  tooltip: '%{BKY_CUSTOM_MACHINE_IFLINE_MORTOR_IR_GET_TOOLTIP}',
  helpUrl: ''
}

Blockly.Blocks['machine_ifline_mortor_ir_get'] = {
  init: function () {
    this.jsonInit(blockJson)
  }
}

Blockly.Python['machine_ifline_mortor_ir_get'] = function (block) {
  if (!block.disabled) {
    Blockly.Python.definitions_.import_ifline = 'import ifline'
    Blockly.Python.definitions_.init_ifline_mortor_ir = 'ifline.mortorIrInit()'
  }
  let dropdownIr = block.getFieldValue('IR')
  let code = `ifline.${dropdownIr}()`
  return [code, Blockly.Python.ORDER_ATOMIC]
}
